import React, { Component } from 'react'

import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import FaClose from "react-icons/lib/fa/close"
import "./PolicyRegScrollbar.css"

class PolicyRegScrollbar extends Component {

  constructor(props) {
    super(props);
    this.state = {}
  }
  handleTermsAndCondPopup = () => {
    document.getElementById("policy-registration-scrollbar").classList.toggle("policy-registration-scrollbar-display")
    document.getElementById("policy-create-card").classList.toggle("policy-create-card-overflow")
  }

  render() {
    return (
      <div className={"policy-registration-scrollbar policy-registration-scrollbar-" + this.props.numb + " "} id="policy-registration-scrollbar">
        {/* <div className="policy-registration-scrollbar-content">   */}
        <div className="policy-registration-scrollbar-header">
          <div className="policy-registration-scrollbar-header-text">
            {this.props.translate("termsandconditions")}
          </div>
          <div className="policy-registration-scrollbar-header-close" onClick={this.handleTermsAndCondPopup}>
            <FaClose />
          </div>
        </div>
        {this.props.translate("terms-conditions-popup-content")}
      </div>

    )
  }
}
const mapStateToProps = state => ({
  translate: getTranslate(state.locale)
});
export default connect(mapStateToProps)(PolicyRegScrollbar);




// WEBPACK FOOTER //
// ./src/components/PolicyRegScrollbar/PolicyRegScrollbar.js